import { Auth0Provider } from '@auth0/auth0-react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { responsiveFontSizes, ThemeProvider, unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
  BrowserRouter as Router, Redirect, Route, Switch,
} from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import Main from './components/Main';
import SubmitProfile from './components/Main/SubmitProfile';
import Success from './components/Main/Success';
import { TypistSpeedProvider } from './components/Typist';
import UTMParamsProcessor from './components/UTMParamsProcessor';
import routes from './routes';

let theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Inter',
      'sans-serif',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#6474ff',
    },
    secondary: {
      main: '#e17269',
    },
  },
});

theme = responsiveFontSizes(theme);

const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Auth0Provider
        domain="matildaexp.us.auth0.com"
        clientId="OQXEeXB4HQpLL1ksvNO095hgPmpevKmi"
        redirectUri={window.location.origin}
      >
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider>
            <Router>
              <UTMParamsProcessor />
              <TypistSpeedProvider>
                <CssBaseline />
                <Header />
                <Switch>
                  <Route path={routes.steps.submitProfile}>
                    <SubmitProfile />
                  </Route>
                  <Route path={routes.steps.success}>
                    <Success />
                  </Route>
                  <Route path={routes.steps.withPage}>
                    <Main />
                  </Route>
                  <Route path={routes.steps.root}>
                    <Main />
                  </Route>
                  <Route>
                    <Redirect to={routes.steps.root} />
                  </Route>
                </Switch>
                <Footer />
              </TypistSpeedProvider>
            </Router>
          </SnackbarProvider>
        </QueryClientProvider>
      </Auth0Provider>
    </ThemeProvider>
  );
}

export default App;
